import { useEffect, useMemo, useRef, useState } from 'react';
import { ChapterRail } from './components/ChapterRail';
import { ChapterBookPage } from './components/ChapterBookPage';
import { DayTwoPage } from './components/DayTwoPage';
import { FieldGuidePage } from './components/FieldGuidePage';
import { PreviewPage } from './components/PreviewPage';
import { travelChapters } from './chapterData';
import { chapterNav } from './data';
import type { PageId } from './types';

const pageIds = new Set<PageId>(chapterNav.map((item) => item.id));

function readHashPage(): PageId {
  const hash = window.location.hash.replace('#', '') as PageId;
  return pageIds.has(hash) ? hash : 'day1';
}

export function App() {
  const [page, setPage] = useState<PageId>(readHashPage);
  const stageRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const onHashChange = () => setPage(readHashPage());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    stageRef.current?.scrollTo({ top: 0, left: 0 });
    window.scrollTo({ top: 0, left: 0 });
  }, [page]);

  const activeItem = useMemo(() => chapterNav.find((item) => item.id === page) ?? chapterNav[0], [page]);

  const changePage = (nextPage: PageId) => {
    window.location.hash = nextPage;
    setPage(nextPage);
  };

  return (
    <div className="app-shell">
      <ChapterRail activePage={page} onPageChange={changePage} />
      <main className="book-stage" aria-label="Book content" ref={stageRef}>
        <header className="topbar">
          <div>
            <p className="topbar-title">额吉的故乡</p>
            <p className="topbar-subtitle">小小草原探险家旅行手册 · iPad Web Book</p>
          </div>
          <div className="topbar-context">
            <span>{activeItem.day}</span>
            <span>{activeItem.title}</span>
          </div>
        </header>
        {page === 'day2' ? (
          <DayTwoPage />
        ) : page === 'guide' ? (
          <FieldGuidePage />
        ) : page in travelChapters ? (
          <ChapterBookPage chapter={travelChapters[page as keyof typeof travelChapters]} />
        ) : (
          <PreviewPage page={page} />
        )}
      </main>
    </div>
  );
}
